export enum CurrencySymbol {
  USD = '$',
  CAD = 'CA$',
  AUD = 'A$',
  EUR = '€',
  GBP = '£',
  MXN = 'Mex$',
  ARS = 'Arg$',
  CLP = 'Ch$',
  BRL = 'R$',
  COP = 'Col$',
  CRC = '₡',
  DOP = 'RD$',
  PEN = 'S/',
  PAB = 'B/.',
  UYU = '$U',
  JPY = '¥',
  PLN = 'zł',
  RON = 'lei',
  THB = '฿',
  TRY = '₺',
  TWD = 'NT$',
  VND = '₫',
  ILS = '₪',
}

export enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  AUD = 'AUD',
  EUR = 'EUR',
  GBP = 'GBP',
  MXN = 'MXN',
  ARS = 'ARS',
  CLP = 'CLP',
  BRL = 'BRL',
  COP = 'COP',
  CRC = 'CRC',
  DOP = 'DOP',
  PEN = 'PEN',
  PAB = 'PAB',
  UYU = 'UYU',
  JPY = 'JPY',
  PLN = 'PLN',
  RON = 'RON',
  THB = 'THB',
  TRY = 'TRY',
  TWD = 'TWD',
  VND = 'VND',
  ILS = 'ILS',
}

const currencySymbols: Record<Currency, CurrencySymbol> = {
  [Currency.USD]: CurrencySymbol.USD,
  [Currency.CAD]: CurrencySymbol.CAD,
  [Currency.AUD]: CurrencySymbol.AUD,
  [Currency.EUR]: CurrencySymbol.EUR,
  [Currency.GBP]: CurrencySymbol.GBP,
  [Currency.MXN]: CurrencySymbol.MXN,
  [Currency.ARS]: CurrencySymbol.ARS,
  [Currency.CLP]: CurrencySymbol.CLP,
  [Currency.BRL]: CurrencySymbol.BRL,
  [Currency.COP]: CurrencySymbol.COP,
  [Currency.CRC]: CurrencySymbol.CRC,
  [Currency.DOP]: CurrencySymbol.DOP,
  [Currency.PEN]: CurrencySymbol.PEN,
  [Currency.PAB]: CurrencySymbol.PAB,
  [Currency.UYU]: CurrencySymbol.UYU,
  [Currency.JPY]: CurrencySymbol.JPY,
  [Currency.PLN]: CurrencySymbol.PLN,
  [Currency.RON]: CurrencySymbol.RON,
  [Currency.THB]: CurrencySymbol.THB,
  [Currency.TRY]: CurrencySymbol.TRY,
  [Currency.TWD]: CurrencySymbol.TWD,
  [Currency.VND]: CurrencySymbol.VND,
  [Currency.ILS]: CurrencySymbol.ILS,
};

export const convertCurrencyToSymbol = (currency: Currency): CurrencySymbol => {
  return currencySymbols[currency] ?? CurrencySymbol.USD;
};
